module.exports = __webpack_public_path__ + "img/img_pessoas_celular.3d84aa8e.svg";